export const fontSize = { style: { fontSize: 16, fontWeight:400 } };
export const labelFontSize = { style: { fontSize: 14, fontWeight:500 } };
export const max_50_characters = {maxLength:50};
export const max_100_characters = {maxLength:100};
export const max_134_characters = {maxLength:134};
export const max_250_characters = {maxLength:250};
export const max_255_characters = {maxLength:255};
export const max_500_characters = {maxLength:500};
